// Returns a per-user localStorage key prefix.
// Admin and expert users keep a stable bucket so their data never mixes with another profile.
export const getUserPrefix = () => {
  try {
    const userJson = localStorage.getItem('smm_crm_current_user');
    if (userJson) {
      const user = JSON.parse(userJson);
      if (user?.id) {
        const safeId = String(user.id).trim().replace(/[^a-zA-Z0-9_-]/g, '_');
        return `user_${safeId}_`;
      }
    }

    const role = localStorage.getItem('smm_crm_current_role');
    if (role === 'Admin') return 'user_admin_';
  } catch {}

  return 'user_admin_';
};

export const getUserKey = (key) => `smm_crm_${getUserPrefix()}${key}`;

export const getCurrentUserId = () => {
  try {
    const userJson = localStorage.getItem('smm_crm_current_user');
    if (userJson) {
      const user = JSON.parse(userJson);
      if (user?.id) return String(user.id);
    }
  } catch {}

  return 'admin';
};

export const readScopedStorage = (key, fallback) => {
  const scopedKey = getUserKey(key);

  try {
    const scopedValue = localStorage.getItem(scopedKey);
    if (scopedValue !== null) return JSON.parse(scopedValue);
  } catch {}

  if (getCurrentUserId() !== 'admin') return fallback;

  try {
    const legacyKey = `smm_crm_${key}`;
    const legacyValue = localStorage.getItem(legacyKey);
    if (legacyValue !== null) {
      localStorage.setItem(scopedKey, legacyValue);
      return JSON.parse(legacyValue);
    }
  } catch {}

  return fallback;
};

export const writeScopedStorage = (key, value) => {
  try {
    localStorage.setItem(getUserKey(key), JSON.stringify(value));
  } catch {}
};
